// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"36940a9e","752":"f5726c37","770":"00913ad5"}[chunkId] + ".chunk.css";
};